/*
 * @Author: manuelzhao manuelzhao@tencent.com
 * @Date: 2022-10-21 22:11:22
 * @LastEditors: manuelzhao manuelzhao@tencent.com
 * @LastEditTime: 2022-12-09 12:33:42
 * @FilePath: /wemeet-web-activity/src/pages/event/[eventid]/registration/buyer/components/hostPanel/hooks.ts
 * @Description: 主办方一些hooks
 */
import { useEffect, useMemo, useState } from 'react';
import { message } from '@tencent/tea-component';
import { HostDetailRes } from '@model/host-account';
import dataReport from '@utils/data-report';
import { useToggleFollowHost } from 'src/components/HomeHeader';

const EVENT_SPACE_SHOW_GUIDE_REGISTRATION = 'EVENT_SPACE_SHOW_GUIDE_REGISTRATION';
type RECORD = {
  notShow?: boolean;
  notShowHostId?: Array<string | number>;
};

/**
 * 获取是否显示过引导的记录
 * @returns records
 */
const getShowRecord = () => {
  let parseRecord: RECORD = {};
  try {
    const showGuideRecord = localStorage?.getItem?.(EVENT_SPACE_SHOW_GUIDE_REGISTRATION);
    if (showGuideRecord) {
      parseRecord = JSON.parse(showGuideRecord);
    }
  } catch (e) {
    // 处理失败
    window.nextAegis.infoAll(
      `[EVENT_SPACE_SHOW_GUIDE_REGISTRATION]--storage get error: ${JSON.stringify(e)}`,
    );
  }
  return parseRecord;
};
/**
 * 判断是否需要显示关注引导
 * @param hostId 主办方id
 */
const judgeShowGuide = (hostId: string | number, subscribe: boolean): boolean => {
  if (!subscribe) {
    return false;
  }
  const parseRecord: RECORD = getShowRecord();

  if (parseRecord?.notShow) {
    return false;
  }

  if (parseRecord?.notShowHostId?.includes?.(hostId.toString())) {
    return false;
  }

  return true;
};

/**
 * 设置是否还需要继续显示
 * 1. 有主办方id的，只保存该主办方id不再显示
 * 2. 无主办方id的，就以后都不显示
 * @param hostId 主办方id
 */
export const setJudgeShowRecord = (hostId?: string | number) => {
  const parseRecord: RECORD = getShowRecord();

  if (hostId) {
    const recordIds = parseRecord.notShowHostId || [];
    if (!recordIds.includes?.(hostId)) {
      recordIds?.push(hostId);
      parseRecord.notShowHostId = recordIds;
    }
  } else {
    parseRecord.notShow = true;
  }

  localStorage?.setItem?.(EVENT_SPACE_SHOW_GUIDE_REGISTRATION, JSON.stringify(parseRecord));
};

export const hostHook = (
  { host_detail, is_subscribed, is_owned }: HostDetailRes['data'],
  subscribeBack?: (subscribe: boolean) => void,
  isCanvasPage?: boolean,
) => {
  const [isFollow, setIsFollow] = useState(!!is_subscribed);
  const labels = useMemo(
    () =>
      host_detail?.label?.map((item) => ({
        text: item,
        undeletable: true,
      })),
    [host_detail],
  );

  useEffect(() => {
    setIsFollow(!!is_subscribed);
  }, [is_subscribed]);

  const toggleFollowHost = useToggleFollowHost(
    isFollow,
    host_detail.host_id,
    !!is_owned,
    host_detail,
    (isSubscribe: boolean) => {
      dataReport('e#event_registrationpage#follow_button#click', {
        follow_state: isSubscribe ? 0 : 1,
        registration_page_style: isCanvasPage ? 1 : 0,
      });

      if (isSubscribe) {
        const willShow = judgeShowGuide(host_detail.host_id, isSubscribe);
        !willShow && message.success({ content: '关注成功' });
        subscribeBack?.(willShow);
      } else {
        message.success({ content: '取消关注成功' });
      }
      setIsFollow(isSubscribe);
    },
    true,
  );

  return {
    labels,
    toggleFollowHost,
    isFollow,
  };
};
